import {
  Select,
  Space,
  Text,
  Image,
  Group,
  Stack,
  Box,
  Flex,
} from "@mantine/core";
import type { FieldValueProps } from "../../types";
import type { MultiShadeCharacteristics } from "@jasper/client-models";
import { MultiShadeSelector } from ".";
import { useTranslation } from "react-i18next";

export interface MultiShadeFormProps extends FieldValueProps<MultiShadeCharacteristics> {
  itemShades: { value: string; label: string }[];
  disabled?: boolean;
}

export const MultiShadeFormV1 = ({
  value,
  itemShades,
  errors,
  onChange,
  disabled,
}: MultiShadeFormProps) => {
  const { t } = useTranslation("forms");

  const incisalShadeLabel = value?.incisalShade
    ? itemShades.find(obj => obj.value === value.incisalShade)?.label
    : "";

  const baseShadeLabel = value?.baseShade
    ? itemShades.find(obj => obj.value === value.baseShade)?.label
    : "";

  const gingivalShadeLabel = value?.gingivalShade
    ? itemShades.find(obj => obj.value === value.gingivalShade)?.label
    : "";

  return (
    <Group w="100%">
      <Stack flex="3" gap={1}>
        <Text size="sm" style={{ fontWeight: "bold" }}>
          {t("forms.multiShadeCharacteristics.labels.incisalShade")}
        </Text>
        <Select
          disabled={disabled}
          value={value?.incisalShade ?? null}
          onChange={incisalShade =>
            onChange({
              ...value,
              incisalShade: incisalShade ?? undefined,
            })
          }
          data={itemShades}
          placeholder={t(
            "forms.multiShadeCharacteristics.placeholders.incisalShade"
          )}
          error={
            errors?.incisalShade
              ? t("forms.multiShadeCharacteristics.errors.incisalShade")
              : undefined
          }
        />
        <Space h="md" />
        <Text size="sm" style={{ fontWeight: "bold" }}>
          {t("forms.multiShadeCharacteristics.labels.baseShade")}
        </Text>
        <Select
          disabled={disabled}
          value={value?.baseShade ?? null}
          onChange={baseShade =>
            onChange({ ...value, baseShade: baseShade ?? undefined })
          }
          data={itemShades}
          placeholder={t(
            "forms.multiShadeCharacteristics.placeholders.baseShade"
          )}
          error={
            errors?.baseShade
              ? t("forms.multiShadeCharacteristics.errors.baseShade")
              : undefined
          }
        />
        <Space h="md" />
        <Text size="sm" style={{ fontWeight: "bold" }}>
          {t("forms.multiShadeCharacteristics.labels.gingivalShade")}
        </Text>
        <Select
          disabled={disabled}
          value={value?.gingivalShade ?? null}
          onChange={gingivalShade =>
            onChange({
              ...value,
              gingivalShade: gingivalShade ?? undefined,
            })
          }
          data={itemShades}
          placeholder={t(
            "forms.multiShadeCharacteristics.placeholders.gingivalShade"
          )}
          error={
            errors?.gingivalShade
              ? t("forms.multiShadeCharacteristics.errors.gingivalShade")
              : undefined
          }
        />
      </Stack>
      <Box flex="1">
        <Flex justify="center" pos="relative">
          <Image w="150px" src={MultiShadeSelector} />
          <Text pos="absolute" w="100%" left={0} top="8%" ta="center">
            {incisalShadeLabel}
          </Text>
          <Text pos="absolute" w="100%" left={0} top="43%" ta="center">
            {baseShadeLabel}
          </Text>
          <Text pos="absolute" w="100%" left={0} top="77%" ta="center">
            {gingivalShadeLabel}
          </Text>
        </Flex>
      </Box>
      <Space h="md" />
    </Group>
  );
};
